import Api from '../Base'

class GetApprovalsBySpacePlan extends Api {
  requestUrl = `/api/SpacePlan/${this.getParams().id}/SpacePlanApprovals`
}
export default GetApprovalsBySpacePlan
